import React, { useState } from 'react';
import { CaretRightOutlined } from '@ant-design/icons';
import { Row, Layout, message, Spin } from 'antd';
import { JobForm } from './job-form';
import jobsService from '../../../services/jobs.service';
import { Link, useNavigate } from 'react-router-dom';
import { notifyError, notifySuccess } from '../../../utils/notification';
import { ContentBox } from '../../../components';
import authService from '../../../services/auth.service';
import { AppRoutes } from '../../../enums';

const { Content } = Layout;
export const AddJobSection: React.FC<any> = props => {
	const navigate = useNavigate();

	const [loading, setLoading] = useState(false);
	const onSubmit = async data => {
		setLoading(true);
		let response;
		try {
			response = await jobsService.postJob(data);
			if (response === null) throw new Error('Sorry!, something went wrong, Please try again later.');
		} catch (e: any) {
			console.error(e.message);
			notifyError(e.message);
			return;
		} finally {
			setLoading(false);
		}
		navigate(AppRoutes.JOBS_DASHBOARD);
		notifySuccess('Your job is now posted. Expect interested candidates within 2-4 business days.');
	};

	const profile = authService.getUserData();

	return (
		<Content style={{ backgroundColor: '#ffffff', height: '100%' }}>
			<ContentBox marginTop={0} minHeight={150}>
				{profile && (
					<Row className="job-view d-flex align-items-center mb-3 justify-content-center justify-content-lg-start">
						<Link to={`/dashboard/company/${profile.company.id}`}>{profile.company.name}</Link>
						<CaretRightOutlined className="mx-1" />
						<Link to={`/dashboard/add-job`}>Add Job</Link>
					</Row>
				)}
				<Row className="job-view d-flex flex-column flex-lg-row align-items-center align-items-lg-stretch justify-content-center justify-content-lg-start">
					<h1>Add Job</h1>
				</Row>
			</ContentBox>
			<Spin spinning={loading}>
				<JobForm {...props} onSubmit={onSubmit} />
			</Spin>
		</Content>
	);
};
